import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import types from './types';

const actions = {
  async getPageAnalytics({ commit }, { companyId, period = '30d' }) {
    commit(types.GET_PAGE_ANALYTICS_START);
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.companyPageAnalytics(companyId)}?period=${period}`,
        isToken: true,
      });
      commit(types.GET_PAGE_ANALYTICS_SUCCESS, data);
    } catch (error) {
      commit(types.GET_PAGE_ANALYTICS_FAILURE);
    }
  },
};

export default actions;
